import { Footnote12Description } from "@/components/typography/Footnote12Description";
import { ItemDetailDto } from "@/types/dto/item-detail-dto";
import { UserDto } from "@/types/dto/user-dto";
import { TableHeader } from "@/types/table-header";
import { Checkbox, Table } from "flowbite-react";
import { CheckboxColor } from "../../../common/enum/checkbox-color";
import { CustomCell } from "../CustomCell";
import { PartnerItemTableFooter } from "./PartnerItemTableFooter";
import { PartnerItemTableRow } from "./PartnerItemTableRow";
import { DiscountDto } from "@/types/dto/discount-dto";

interface Props {
  user: UserDto;
  searchItemName: string;
  items: ItemDetailDto[];
  checkedItemIds: number[];
  gradeDiscount: number;
  addCheckedItemId: (id: number) => void;
  checkAllItemIds: () => void;
  removeCheckedItemId: (id: number) => void;
  openIncentivesModal: () => void;
  getPage: (searchItemName: string) => void;
  discounts: DiscountDto[];
}

const headers: TableHeader[] = [
  // { title: "체크박스", width: "w-[52px]", align: "flex justify-center" },
  { title: "상품명", width: "w-[500px]" },
  { title: "카테고리", width: "w-[160px]" },
  { title: "발주 수", width: "w-[120px]" },
  { title: "기본 할인", width: "w-[120px]" },
  { title: "인센티브 할인", width: "w-[360px]" },
  { title: "최종가", width: "w-[136px]", align: "flex justify-center" },
];
export const PartnerItemTable: React.FC<Props> = ({
  user,
  searchItemName,
  items,
  checkedItemIds,
  gradeDiscount,
  addCheckedItemId,
  checkAllItemIds,
  removeCheckedItemId,
  openIncentivesModal,
  getPage,
  discounts,
}) => {
  return (
    <div className="overflow-x-auto rounded-lg border h-[420px] box-border ">
      <Table>
        <Table.Head className="sticky top-0 z-10">
          <Table.HeadCell
            key={"checkbox"}
            className={"w-[52px] h-[52px] p-0 border-b bg-gray-100"}
          >
            <CustomCell>
              <Checkbox
                color={
                  checkedItemIds.length === items.length
                    ? CheckboxColor.DARK
                    : ""
                }
                checked={checkedItemIds.length === items.length}
                onChange={checkAllItemIds}
              />
            </CustomCell>
          </Table.HeadCell>
          {headers.map((header) => (
            <Table.HeadCell
              key={header.title}
              className={header.width + " h-[52px] p-0 border-b bg-gray-100"}
            >
              <div className={header.align}>
                <CustomCell>
                  <Footnote12Description
                    className={"text-semantic-text-secondary"}
                  >
                    {header.title}
                  </Footnote12Description>
                </CustomCell>
              </div>
            </Table.HeadCell>
          ))}
        </Table.Head>
        <Table.Body className="divide-y">
          {items.map((item, index) => {
            const discount = discounts.find(
              (discount) => discount?.item?.id === item.id
            );
            return (
              <PartnerItemTableRow
                key={item.id}
                user={user}
                searchItemName={searchItemName}
                data={item}
                checkedItemIds={checkedItemIds}
                gradeDiscount={gradeDiscount}
                addCheckedItemId={addCheckedItemId}
                removeCheckedItemId={removeCheckedItemId}
                getPage={getPage}
                openIncentivesModal={openIncentivesModal}
                discount={discount}
              />
            );
          })}
          <PartnerItemTableFooter
            headersLength={Object.values(headers).length}
            openIncentivesModal={openIncentivesModal}
            disabled={checkedItemIds.length === 0}
            items={items}
            checkedItemIds={checkedItemIds}
            user={user}
            getPage={getPage}
            searchItemName={searchItemName}
            discounts={discounts}
          />
        </Table.Body>
      </Table>
    </div>
  );
};
